import React, {Component} from 'react';
import {Translation} from 'react-i18next';

import CallForm from '../containers/CallFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';

class CallEditScreen extends Component {

  scrollToTop = () => {
    Logger.log('debug', `CallEditScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {
    return (
      <Translation>{(t) => 
        <div>
          <DocumentHead title={t('call_route_edit')} />
          <CallForm id={this.props.match.params.id} />
        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default CallEditScreen;

Logger.log('silly', `CallEditScreen loaded.`);
